const templates =  {
    "shop.okraina.ru": {
        title: "Личный кабинет",
        tags: [
            {
                name: "description",
                content: "",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
    "dostavka.okraina.ru": {
        title: "Личный кабинет",
        tags: [
            {
                name: "description",
                content: "",
            },
            {
                name: "keywords",
                content: "",
            }
        ]
    },
}

export default templates;